module.exports = __webpack_public_path__ + "media/images/sp/static/service-flow-1a5517d7e3c37b8966cbdd2cc3db4bb9.png";